import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DialogHeader from './DialogHeader'
import { useTranslation } from 'react-i18next'
import apiManagerUser from 'api/manager-users'
import { getUserProperty, toastError, toastSuccess } from 'utils/helpers'
import { TOAST_DEFAULT } from 'constants/toast'
import useCheck2FaStatus from 'hooks/useCheck2FaStatus'
import { USER_PROPERTIES } from 'constants/user'
import { useDispatch } from 'react-redux'
import { endSession as logout } from 'store/sessionSlice'

const DialogStop2FA = ({ onCancel, onClose }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { isRequired2FAEmail, isRequired2FARole } = useCheck2FaStatus()
    const [isRequired2FA, setIsRequired2FA] = useState(false)

    const handleDisable2FA = async () => {
        try {
            const res = await apiManagerUser.disable2FA()
            if (res?.code === 0) {
                toastSuccess(t('toast.success.title.disable2fa'))

                if (isRequired2FA) dispatch(logout())
            } else {
                toastError(t(TOAST_DEFAULT.ERROR))
            }
        } catch (error) {
            console.log(error)
            toastError(t(TOAST_DEFAULT.ERROR))
        }
    }

    const handleStop = () => {
        handleDisable2FA()
        onClose()
    }

    const handleClose = () => {
        onClose()
        onCancel()
    }

    useEffect(() => {
        const checkRequired2FA = async () => {
            const email = getUserProperty(USER_PROPERTIES.EMAIL)
            const isRequiredEmail = await isRequired2FAEmail(email)
            const isRequiredRole = await isRequired2FARole()

            setIsRequired2FA(isRequiredEmail || isRequiredRole)
        }

        checkRequired2FA()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Dialog id='dlg-reject-share-info' open onClose={handleClose}>
            <DialogHeader titleKey={'multiFactor.stop2fa'} onClose={handleClose} />
            <DialogContent>
                <Typography>{t('multiFactor.descStop2fa')}</Typography>
                <Typography>{t('multiFactor.descStop2fa2')}</Typography>
                {isRequired2FA && <Typography color={theme => theme.palette.primary.main}>{t('multiFactor.disableRequiredUser')}</Typography>}
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose}>{t('actions.cancel')}</Button>
                <Button onClick={handleStop}>{t('actions.disable2fa')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogStop2FA
